import { Injectable, OnDestroy } from '@angular/core';

import { LeftSidebarManagementService } from '../../../Common/Layout/services/left-sidebar-management.service';
import { UsersService } from '../../../Core/Users/services/users.service';
import { ReportsLeftSidebarService } from './reports-left-sidebar.service';
import { ReportsService } from '../../../Common/Reports/services/reports.service';
import { ActionsEnum } from '../../../Common/Basic/enums/actions.enum';
import { AuditableModel } from '../../../Common/Misc/models/auditable.model';
import { DisplayGroupsService } from '../../../Common/Layout/services/display-groups.service';
import { LocalizationService } from '../../../Core/Localization/services/localization.service';
import { DisplayGroupModel } from '../../../Common/Layout/models/display-group.model';


@Injectable()
export class ReportsLeftSidebarManagementService extends LeftSidebarManagementService implements OnDestroy {

    constructor(
        protected usersService: UsersService,
        public leftSidebarService: ReportsLeftSidebarService,
        public reportsService: ReportsService,
        public displayGroupsService: DisplayGroupsService,
        protected localizationService: LocalizationService
    ) {
        super(usersService, leftSidebarService, displayGroupsService, localizationService);

        this.columnsProvider$.next([
            this.itemNameColumn,
            ...this.metadataColumns
        ]);

        this.subscriptions.push(
            this.reportsService.getReportListItems().subscribe(
                reports => {
                    this.allListItems = reports;
                    this.getAuditableFilterOptions(this.allListItems);
                    this.setFilters(this.filters);
                    this.applyFilters();
                }
            )
        );
    }

    public handleBulkItemAction(items: AuditableModel[], groups: DisplayGroupModel[], action: ActionsEnum) {
        this.loading$.next(true);
        const ids = items.map(item => item.id);
        switch(action) {
            case ActionsEnum.delete:
                this.reportsService.confirmBulkDeleteReport(items, groups).subscribe(result => {
                    this.loading$.next(false);
                    this.resetSelectionProvider$.next(result);
                });
                break;
            case ActionsEnum.hide:
            case ActionsEnum.show:
                this.resetSelectionProvider$.next(true);
                this.reportsService.bulkUpdateReportVisibility(ids, action);
                break;
            case ActionsEnum.move:
                this.displayGroupsService.openGroupSelectionDialog(null, true).subscribe({
                    next: (group: DisplayGroupModel) => {
                        this.resetSelectionProvider$.next(true);
                        this.reportsService.updateReportGroup(ids, group);
                    },
                    complete: () => {
                        this.loading$.next(false);
                    }
                });
                break;
            case ActionsEnum.favorite:
                this.reportsService.updateReportFavorites(ids, []);
                break;
            case ActionsEnum.unfavorite:
                this.reportsService.updateReportFavorites([], ids);
                break;
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
